const CONSTANTS = {
  MICROSOFT_GRAPH_TOKEN: "microsoft_graph_token",
  PLATFORM: "platform",
  CONSENT_JUST_GRANTED: "consent_just_granted",
  MAX_SILENT_AUTH_RETRIES: 1,
  // Freshly-granted Microsoft Graph consent can take a few seconds to
  // propagate before a server-side OBO token exchange recognizes it.
  // These are silent background retries behind the loading state, not
  // interactive prompts, so users don't have to notice and re-click.
  CONSENT_PROPAGATION_RETRY_DELAYS_MS: [3000, 5000],
  PER_PAGE: 10,
  COOKIES_DURATION: 30 * 60 * 1000,
  COOKIES_LONG_DURATION: 60 * 60 * 24 * 365 * 10,
  COOKIES: {
    COMPANIES: "companies",
    DOMAIN: "domain",
  },
  GLOBAL_CLASSES: {
    DEFAULT: "default",
    DARK: "dark",
    CONTRAST: "contrast",
  },
};

export default CONSTANTS;
